export class CreateRestoreTemplateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "RestoreTemplateResourceType",
            "format": ""
        },
        {
            "name": "ec2Params",
            "baseName": "ec2Params",
            "type": "Ec2TemplateParams",
            "format": ""
        },
        {
            "name": "s3Params",
            "baseName": "s3Params",
            "type": "S3TemplateParams",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateRestoreTemplateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
